import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { DealerService } from "src/app/core/services/dealer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { CustomerMatchModel } from "src/app/shared/models/DTO/VenueFinance.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { OAuthIntegration } from "src/app/shared/models/oauth-integration";
import { Store } from "src/app/shared/models/store";

@Component({
	selector: "app-contract-finance-venue-customer-list",
	templateUrl: "./contract-finance-venue-customer-list.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ContractFinanceVenueCustomerListComponent implements OnInit {
	@Input() oauthIntegration: OAuthIntegration;
	@Output() oauthIntegrationChange = new EventEmitter<OAuthIntegration>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	accountingCustomerList: CustomerMatchModel[];

	pendingSaveVenue: Store[] = [];

	constructor(public app: AppService, public dealerService: DealerService, public userService: UserService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.customerListGet();
	}

	async customerListGet() {
		const resp = await this.focuslink.contractFinanceDealerCustomerList(this.dealerService.dealer.value.key);
		this.accountingCustomerList = resp.map((i) => new CustomerMatchModel(i));
	}

	setVenueAccountingId(venueKey: number) {
		this.pendingSaveVenue.push(this.dealerService.dealer.value.venues.find((i) => i.key === venueKey));
		this.changesToSaveChange.emit(true);
	}

	async saveVenueChanges() {
		const promiseList = [];
		console.log(this.pendingSaveVenue);
		this.pendingSaveVenue.forEach((venue) => {
			promiseList.push(this.focuslink.venuePost(venue.key, venue));
		});
		await Promise.all(promiseList);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Venue to Accounting matches saved successfully.` });
	}
}
